import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { useColorMode } from '@chakra-ui/react';
import { ChangeEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getSessionManagementPagePath } from '../../App';
import { fetchContext } from '../../api';
import Input from '../../components/input';
import Layout from '../../components/layout';
import { useSession } from '../../hooks/useSession';
import { IUseGetContextResData } from '../../types';

interface IOTPState {
    bookName: string;
    region: string;
    otp: string | null;
    status: string | null;
}

interface IBookOTPStates {
    [bettorAccountId: string]: IOTPState;
}

interface IOTPData {
    [bettorAccountId: string]: string | null;
}

const delay = async (time: number) => {
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
};

export default function OTPEntry() {
    const session = useSession();

    let defaultState: IBookOTPStates = {};
    let bettorAccounts = session?.bettorAccounts || [];
    const { push } = useHistory();
    const [loading, setLoading] = useState(false);
    const { colorMode, toggleColorMode } = useColorMode();

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    const routeToDone = () => {

        if (session?.user?.managementSession) {
            push(getSessionManagementPagePath(session.cid!));
        } else {
            window.close();
            window.location.href = '/done';
        }
    };
    //Get bettorAccount info
    for (let i = 0; i < bettorAccounts.length; i++) {
        defaultState[bettorAccounts[i].id] = {
            bookName: bettorAccounts[i].book.name,
            region: bettorAccounts[i].bookRegion.name,
            otp: '',
            status: null, // not currently in use could use to display OTP entry result
        };
    }

    const checkTFA = async () => {
        //if no bettorAccount have TFA then route to done / close webview
        if (bettorAccounts.filter((x) => x.TFA).length == 0) {
            //refetch context, confirm no TFA, then route to done
            let newResponse = await fetchContext(session?.cid!);
            const responseData: IUseGetContextResData =
                await newResponse.json();
            bettorAccounts = responseData?.bettorAccounts;

            if (bettorAccounts.filter((x) => x.TFA).length == 0) {
                console.log('Check TFA Route to Done');
                routeToDone();
            }
        }
    };

    checkTFA();

    //update
    const [state, setState] = useState(defaultState);
    const handleChange =
        (bettorAccountId: string) => (e: ChangeEvent<HTMLInputElement>) => {
            let newState = Object.assign({}, state);
            newState[bettorAccountId].otp = e.target.value;
            setState(newState);
        };

    const onClick = async () => {
        console.log('Submitting OTP');
        setLoading(true);
        let data: IOTPData = {};
        for (const [key, value] of Object.entries(state)) {
            data[key] = value.otp; //Want to use a regex to catch anything that doesn't fit OTP format, surface error message
        }

        fetch(
            `${
                process.env.REACT_APP_API_BASE || ''
            }/v1/context/?cid=${session?.cid!}`,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Token ${process.env.REACT_APP_SUPERUSER_API_KEY}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    otp: data,
                }),
            }
        ).then((response) => {
            if (response.status == 200){
                routeToDone();
            } else {
                    console.error('OTP Entry non 2xx: ', response.status);
                    //Want to add DD log, error SWAL
                }
            })
            .catch((error) => {
                console.error('OTP Entry Error: ', error);
                //Want to add DD log, error SWAL
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            });
    };

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
            buttons={
                <Button onClick={onClick} isLoading={loading}>
                    Continue
                </Button>
            }
        >
            <Flex
                direction="column"
                align="center"
                gap="32px"
                w="full"
                textAlign="center"
            >
                <Text maxW="294px">
                    Enter the One-Time-Password for the SportsBooks below or
                    leave it blank if you did not receive one.
                </Text>

                {bettorAccounts
                    .filter((x) => x.TFA && x.refreshInProgress)
                    .map((x) => (
                        <Box key={x.id} w="full">
                            <Text fontWeight="bold" mb={4}>
                                {x.book.name} ({x.bookRegion.abbr.toUpperCase()}
                                ):
                            </Text>
                            <Input
                                placeholder="Enter OTP"
                                onChange={handleChange(x.id)}
                            />
                        </Box>
                    ))}
            </Flex>
        </Layout>
    );
}
